import { MapNav2 as View } from 'ui-components'
import { useMapNavStore } from '~map-preview/states/mapNav'
import { useIsWorkspaceMember } from '~map-preview/hooks/useIsWorkspaceMember'
import { Filter } from './Filter'
import { Info } from './Info'
import { MapBreadcrumbs as Breadcrumbs } from './MapBreadcumbs'
import { Search } from './Search'
import { Settings } from './Settings'
import { Share } from './Share'
import { useMap } from '~map-preview/states/map'

export const Nav = () => {
  const { infoGraphicOpen } = useMapNavStore()
  const isWorkspaceMember = useIsWorkspaceMember()
  const map = useMap()

  if (infoGraphicOpen) return null

  return (
    <View
      isPublic={map?.isPublic}
      isWorkspaceMember={isWorkspaceMember}
      slots={{
        Breadcrumbs,
        Filter,
        Search,
        Share,
        Info,
        Settings
      }}
    />
  )
}
